import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import FormInput from './FormInput';
import { MDBContainer, MDBBtn } from 'mdb-react-ui-kit';

const Form = () => {

    const [value, setValues] = useState({
        user_name: '',
        user_email: '',
        message: ''
      });

    const inputs = [
    {
        id: 1,
        name: "user_name",
        type: "text",
        placeholder: "Name",
        errorMessage:
        "Name should be 3-12 characters",
        label: "Name",
        pattern: "^[A-Za-z0-9]{3,12}$",
        required: true,
    },
    {
        id: 2,
        name: "user_email",
        type: "email",
        placeholder: "Email",
        errorMessage: "It should be a valid email address!",
        label: "Email",
        required: true,
    },
    {
        id: 3,
        name: "message",
        type: "text-field",
        placeholder: "Message",
        label: "Message",
        required: true,
    },
    ];

    const form = useRef();

    const onChange = (e) => {
        setValues({ ...value, [e.target.name]: e.target.value });
      };
    
    const sendContactEmail = (e) => {
      e.preventDefault();
      setValues({ user_name: '', user_email: '', message: ''});
      
      emailjs.sendForm("service_fkyoae8", "template_amlmf8a", form.current, "sh2OZ50tQogYUsodY")
        .then((result) => {
          alert(`Message Sent Successfully.. ${result.status + result.text}`)
        }, (error) => {
          alert(`Something went wrong. Please try again.. ${error.text}`)
        });
    };
    
  return (
    <MDBContainer fluid>
            <form onSubmit={sendContactEmail} ref={form}>
                {inputs.map((input) => (
                <FormInput
                    key={input.id}
                    {...input}
                    value={value[input.name]}
                    onChange={onChange}
                />))}
                <MDBBtn className='my-3' size='md' color='dark' type='submit'>Submit Form</MDBBtn>
            </form>
    </MDBContainer>
  )
}

export default Form;